import React from 'react';

import { Filter } from '~/evifields/src/types/Filter';
import { DateValue } from '~/evifields/src/types/Value';
import { useFormatDate } from '~/i18n/hooks/useFormatDate/useFormatDate';

import { TextContainer } from '../TextContainer';
import { coerceFormatDate } from '../utils';

interface Props {
  filter: Filter<DateValue>;
}

export const DateValuesPreview = ({ filter }: Props) => {
  const formatDate = useFormatDate();

  const { values } = filter;
  const [value1, value2] = values;

  return values.length === 1 ? (
    <TextContainer text={coerceFormatDate(value1, formatDate)} />
  ) : (
    <TextContainer.Pair
      delimiter="to"
      texts={[
        coerceFormatDate(value1, formatDate),
        coerceFormatDate(value2, formatDate),
      ]}
    />
  );
};
